<template>
  <div>
    <div class="panel-topnav container-fluid">
      <ul class="nav nav-tabs pull-left">
        <li>
          <h3 class="page-title">
            Investors
          </h3>
        </li>
      </ul>
      <div class="clearfix"></div>
    </div>

    <Filters class="container-fluid filters" @change="onFiltersChange" />

    <div class="container-fluid pane">
      <InvestorListModal ref="investorListModal" />

      <div class="row">
        <div class="col-sm-12" :class="{ 'loader-cover': fetchInProgress }">
          <div
            v-show="investors.length === 0 && !fetchInProgress"
            class="alert alert-info"
          >
            <p>There are no investors to show</p>
          </div>

          <PageNumberLinks
            v-if="investors.length"
            :page="page"
            :total="totalCount"
            show-total
          />

          <table v-show="investors.length > 0" class="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Location</th>
                <th>Investment</th>
                <th>Status</th>
                <th class="text-center">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="investor in investors" :key="investor.id">
                <td>
                  <a
                    href
                    @click.prevent="$refs.investorListModal.open(investor)"
                    >{{ investor.name }}</a
                  >
                </td>
                <td>
                  <span v-if="investor.country">
                    {{ investor.country | countryName }}
                  </span>
                  <span v-if="investor.country && investor.city">,</span>
                  <span v-if="investor.city">{{ investor.city }}</span>
                </td>
                <td>
                  <InlineRange
                    v-if="investor.investment_min || investor.investment_max"
                    :min="investor.investment_min"
                    :max="investor.investment_max"
                  />
                  <span
                    v-if="!(investor.investment_min || investor.investment_max)"
                    >up to 2M</span
                  >
                </td>
                <td>{{ investor.state | capitalize }}</td>
                <td class="flex-center">
                  <InvestorApplyButton :investor="investor" :is-icon="true" />
                </td>
              </tr>
            </tbody>
          </table>

          <PageNumberLinks
            v-if="investors.length"
            :page="page"
            :total="totalCount"
            show-total
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import http from 'services/http'
import router from 'routes'
import { currency, roundedNumber } from '@/filters'
import InlineRange from '@/components/InlineRange'
import notifications from '@/services/notifications'
import PageNumberLinks from '@/components/PageNumberLinks'
import InvestorListModal from './InvestorListModal'
import { countryName } from '@/services/countries'
import InvestorApplyButton from '@/components/InvestorApplyButton'
import Filters from './Filters.vue'
import { omitEmptyKeys } from 'utils'

export default {
  filters: { currency, countryName, roundedNumber },
  components: {
    Filters,
    InlineRange,
    InvestorApplyButton,
    InvestorListModal,
    PageNumberLinks,
  },
  data: () => ({
    lastClickedPasscodeButtonInvestorId: null,
    lastClickedLinkButtonInvestorId: null,
    search: '',
  }),
  computed: {
    ...mapState({
      fetchInProgress: (state) => state.investorList.fetchInProgress,
      page: (state) => state.investorList.page,
      totalCount: (state) => state.investorList.totalCount,
      investors: (state) => state.investorList.investors,
      user: (state) => state.user.data,
    }),
  },
  watch: {
    '$route.query.page'() {
      this.fetch()
    },
  },
  async created() {
    const user = await this.$store.dispatch('user/getUser')

    this.fetch()
  },
  methods: {
    fetch(filters) {
      filters = filters || {}
      filters = Object.assign({}, this.getFilters(), filters)
      filters.startupId = this.user.startupId

      this.$store.dispatch('investorList/fetch', filters)
    },

    onFiltersChange(filters) {
      this.filters = filters
      this.performFiltering()
    },

    performFiltering: _.debounce(function () {
      // perform search if at least two characters were typed
      // also perform for zero characters (user might want to reset query)
      if (this.filters.search.length !== 1) {
        this.fetch({ page: 1 })
      }
    }, 300),

    getFilters() {
      const page = parseInt(this.$route.query.page, 10)
      return omitEmptyKeys({ page, ...this.filters })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~assets/css/helpers.scss';

.table {
  margin: 10px;
}
.card {
  label {
    margin: 5px 5px 0px 0px;
    font-weight: normal;
    font-size: 12px;
  }
  .btn {
    margin: 0px 0px 5px 0px;
    text-align: center;
    width: 80%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.help-container {
  margin: 20px 12px;
}
</style>
